import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
} from '@material-ui/core';

import { formatContabilita } from './../../../utils/info-moduli';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
        padding: '0px',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    minWidth: {
        minWidth: '100%',
    },
    red: {
        backgroundColor: '#d9534f52',
        paddingTop: '0px',
        paddingBottom: '0px',
        '&:hover': {
            backgroundColor: '#ca535085',
        },
    },
    green: {
        backgroundColor: '#00ff0024',
        paddingTop: '0px',
        paddingBottom: '0px',
        '&:hover': {
            backgroundColor: '#00c50069',
        },
    },
    divider: {
        borderTop: '1px solid #00000021'
    },
    sub: {
        marginLeft: '24px',
    },
});


class ModuliContabilita extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isReadOnly: false,
        };

        this.setupChange = this.setupChange.bind(this);
    }

    componentDidMount() {
        if (this.props.contabilita.Contab === false)
            this.setState({ isReadOnly: true });
    }


    componentDidUpdate(propsPrecedenti) {
        //Se cambio profilo predefinito faccio in modo che in caso di attivazione di una checkbox padre le figlie non rimangano disattivate
        if (this.props.contabilita.Contab !== propsPrecedenti.contabilita.Contab) {
            if (this.props.contabilita.Contab === true) this.setState({ isReadOnly: false });
            else this.setState({ isReadOnly: true });
        }
    }

    setupChange(keyName, newValue) {

        if (!this.props.isReadOnly) {
            if (keyName === "Contab") {
                if (newValue === false) {   //metto a false tutte le checkbox figlie
                    this.props.handleChangeFieldModulo('Contabilita', 'Contab', newValue);
                    this.props.handleChangeFieldModulo('Contabilita', 'Analitica', newValue);
                    this.props.handleChangeFieldModulo('Contabilita', 'Cespiti', newValue);
                    this.props.handleChangeFieldModulo('Contabilita', 'SintesiDati', newValue);
                    this.props.handleChangeFieldModulo('Contabilita', 'ModuloFiscale', newValue);
                    if (this.props.tipologia === 'Enterprise') this.props.handleChangeFieldModulo('Contabilita', 'Gold', newValue);

                    this.setState({ isReadOnly: true });
                }
                else {
                    this.props.handleChangeFieldModulo('Contabilita', 'Contab', newValue);

                    this.setState({ isReadOnly: false });
                }
            }
            else {
                this.props.handleChangeFieldModulo('Contabilita', keyName, newValue);
            }
        }

    }

    render() {
        const { classes, contabilita } = this.props;
        const { isReadOnly } = this.state;

        return (
            <List className={classes.root}>


                {
                    Object.keys(contabilita).map((keyName, i) => {
                        const labelId = `checkbox-list-label-${keyName}`;

                        return (
                            <ListItem
                                className={`${contabilita[keyName] === true ? classes.green : classes.red} ${keyName !== 'Contab' ? classes.divider : null}`}
                                key={keyName}
                                role={undefined}
                                dense
                                button
                                disabled={keyName === 'Contab' ? false : isReadOnly}
                                onClick={e => { this.setupChange(keyName, !contabilita[keyName]) }}
                            >
                                <ListItemIcon className={keyName !== 'Contab' ? classes.sub : null}>
                                    <Checkbox
                                        edge="start"
                                        checked={contabilita[keyName]}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={formatContabilita(keyName)} />
                            </ListItem>
                        );
                    })

                }

            </List>

        );

    }
}

ModuliContabilita.propTypes = {
    contabilita: PropTypes.shape({}).isRequired,
    handleChangeFieldModulo: PropTypes.func.isRequired,

    tipologia: PropTypes.string.isRequired,

    isReadOnly: PropTypes.bool.isRequired
};

export default withStyles(styles)(ModuliContabilita);